import React from 'react';
import classnames from 'classnames';

import Heading from './renderers/Heading';
import Paragraph from './renderers/Paragraph';
import PostMeta from './PostMeta';
import Cover from './Cover';
import Bullet from './Bullet';

const Hero = ({
  alignment = 'center',
  explode = false,
  showBlob = true,
  title,
  subTitle,
  coverImage,
  authors,
  friendlyPublishedOn,
  friendlyStartDate,
  items = [],
  promoBullet,
  speakers,
  children,
  type,
}) => {
  const centerAligned = alignment === 'center';
  const leftAligned = !centerAligned;

  const wrapperClass = classnames('lg:py-6', {
    'text-center max-w-4xl mx-auto': centerAligned,
  });

  const positonClass = classnames('flex -mx-6', {
    'flex-col': centerAligned,
    'flex-col md:flex-row md:items-center': leftAligned,
  });

  const contentClass = classnames('relative z-20', {
    'md:w-1/2': leftAligned,
    'pl-6 pr-6 lg:pr-16': explode,
    'px-6': !explode,
  });

  const imageClass = classnames('relative px-6 md:mt-0', {
    'w-full max-w-5xl mx-auto pt-6 md:pt-12': centerAligned,
    'w-full md:w-1/2 pt-6 md:pt-0': leftAligned,
  });

  const blobClass = classnames(
    'hidden md:block absolute top-0 right-0 text-titan-white fill-current transform',
    {
      '-mr-40 -mt-40 lg:scale-110': !explode,
      'lg:-mr-84 lg:-mt-84 -mr-40 -mt-40 lg:scale-150': explode,
    }
  );

  const showMeta = friendlyPublishedOn || friendlyStartDate;

  const showShadow = explode && showBlob;

  return (
    <div className={wrapperClass}>
      <div className={positonClass}>
        <div className={contentClass}>
          <div className="lg:-mt-6">
            {promoBullet && <Bullet {...promoBullet} />}
            <Heading>{title}</Heading>
          </div>

          <div className="max-w-3xl mx-auto mt-6">
            {showMeta ? (
              <PostMeta
                date={friendlyPublishedOn || friendlyStartDate}
                people={authors || speakers}
                type={type}
              />
            ) : (
              <Paragraph children={subTitle} className="text-lg text-zodiac" />
            )}
          </div>

          {children && <div className="pt-6">{children}</div>}
        </div>

        {coverImage && (
          <div className={imageClass}>
            <Cover
              image={coverImage}
              title={title}
              alt={title}
              items={items}
              explode={explode}
              showShadow={showShadow}
            />

            {leftAligned && showBlob && (
              <svg
                style={{
                  zIndex: '-10',
                }}
                className={blobClass}
                viewBox="0 0 600 600"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g transform="translate(300,300)">
                  <path d="M138.9,-146.2C174,-103.7,192.5,-51.9,183.2,-9.3C173.9,33.2,136.8,66.5,101.6,95.5C66.5,124.5,33.2,149.2,-16.1,165.4C-65.5,181.5,-131.1,189.1,-178.6,160.1C-226.1,131.1,-255.5,65.5,-254,1.5C-252.5,-62.5,-219.9,-124.9,-172.4,-167.4C-124.9,-209.9,-62.5,-232.5,-5.3,-227.2C51.9,-221.9,103.7,-188.7,138.9,-146.2Z" />
                </g>
              </svg>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
